import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['María', 'Laura', 'Carolina', 'Ana', 'Sofía', 'Valentina', 'Camila'];
const CITIES = ['Buenos Aires', 'CDMX', 'Bogotá', 'Santiago', 'Lima', 'Montevideo', 'San José'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Interval between 8-12 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.random() * (12000 - 8000) + 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-8">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0,
      y: 50
    }} animate={{
      x: 0,
      opacity: 1,
      y: 0
    }} exit={{
      x: -100,
      opacity: 0,
      y: 50
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-full md:w-auto" data-id="element-9">
          <div className="bg-white rounded-lg shadow-xl p-4 flex items-center gap-3 border-l-4 border-purple-500 relative overflow-hidden" data-id="element-10">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-11">
              <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-12" />
            </div>
            <div className="pr-6" data-id="element-13">
              <p className="text-sm font-medium text-gray-900" data-id="element-14">
                <span className="font-bold text-purple-700" data-id="element-15">{data.name}</span>{' '}
                de {data.city}
              </p>
              <p className="text-xs text-gray-500" data-id="element-16">
                acaba de comprar este libro digital
              </p>
            </div>
            <button onClick={() => setIsVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600" data-id="element-17">
              <X className="w-3 h-3" data-id="element-18" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}